import React, { useMemo } from 'react';
import { Box, Typography, Paper } from '@mui/material';

interface NotificationHistoryCardProps {
  history: number[];
  isLoading: boolean;
}

export const NotificationHistoryCard = React.memo(function NotificationHistoryCard({ history, isLoading }: NotificationHistoryCardProps) {
  const chartBars = useMemo(() => {
    if (!history || history.length === 0) return null;
    
    const maxValue = Math.max(...history);
    const safeMax = maxValue > 0 ? maxValue : 1;

    return history.map((dayValue, index) => {
      const heightPercent = Math.round((dayValue / safeMax) * 100);
      const isToday = index === history.length - 1;

      return (
        <Box 
          key={index} 
          sx={{ 
            flex: 1, 
            height: `${heightPercent}%`, 
            minHeight: dayValue > 0 ? '4px' : '2px', 
            opacity: dayValue > 0 ? 1 : 0.3, 
            bgcolor: isToday ? 'primary.main' : 'divider', 
            borderRadius: '2px 2px 0 0',
            transition: 'height 0.3s ease, background-color 0.2s ease',
            '&:hover': { 
              bgcolor: isToday ? 'primary.dark' : 'text.secondary',
              opacity: 1
            }
          }} 
          title={`Dia ${index + 1}: ${dayValue} envios`}
        />
      );
    });
  }, [history]);

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', 
        bgcolor: 'background.paper', opacity: isLoading ? 0.6 : 1, transition: 'opacity 0.2s ease'
      }}
    >
      <Typography variant="body2" color="text.secondary" fontWeight="bold" sx={{ mb: 0.5 }}>
        Volume de Notificações (30 dias):
      </Typography>
      <Typography variant="caption" color="text.primary" fontWeight="bold" display="block">
        Atividade de Catraca / Comunicados
      </Typography>
      
      <Box aria-hidden="true" sx={{ display: 'flex', alignItems: 'flex-end', height: 60, gap: '2px', mt: 2, borderBottom: '1px solid', borderColor: 'divider', pb: 0.5 }}>
        {chartBars || <Typography variant="caption" color="text.disabled" sx={{ width: '100%', textAlign: 'center', pb: 2 }}>Sem dados no período</Typography>}
      </Box>
    </Paper>
  );
});